export default __webpack_public_path__ + "static/media/PBLC-2.cae020ae.jpg";